module.exports = __webpack_public_path__ + "img/553-42dfb3.png";